import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE_class_variance_authority_159ad65c__ from "class-variance-authority";
import * as __WEBPACK_EXTERNAL_MODULE__Paragraph_module_js_e8e77f94__ from "./Paragraph.module.js";
const paragraphClass = (0, __WEBPACK_EXTERNAL_MODULE_class_variance_authority_159ad65c__.cva)(__WEBPACK_EXTERNAL_MODULE__Paragraph_module_js_e8e77f94__["default"].paragraph, {
    variants: {
        size: {
            small: __WEBPACK_EXTERNAL_MODULE__Paragraph_module_js_e8e77f94__["default"].small,
            regular: ''
        },
        textAlignment: {
            left: __WEBPACK_EXTERNAL_MODULE__Paragraph_module_js_e8e77f94__["default"].textAlignLeft,
            start: __WEBPACK_EXTERNAL_MODULE__Paragraph_module_js_e8e77f94__["default"].textAlignLeft,
            center: __WEBPACK_EXTERNAL_MODULE__Paragraph_module_js_e8e77f94__["default"].textAlignCenter,
            right: __WEBPACK_EXTERNAL_MODULE__Paragraph_module_js_e8e77f94__["default"].textAlignRight,
            end: __WEBPACK_EXTERNAL_MODULE__Paragraph_module_js_e8e77f94__["default"].textAlignRight,
            justify: __WEBPACK_EXTERNAL_MODULE__Paragraph_module_js_e8e77f94__["default"].textAlignJustify,
            '': ''
        }
    }
});
function Paragraph({ size = 'regular', textAlignment = 'left', children, className, ref, ...other }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("p", {
        ref: ref,
        className: paragraphClass({
            size,
            textAlignment,
            className
        }),
        ...other,
        children: children
    });
}
export { Paragraph as default };

//# sourceMappingURL=Paragraph.js.map